import React from 'react';
import { OutsideClick } from '@cian/outside-click-component';
import { mergeStyles } from '@cian/utils/lib/shared/style';
import { IFavoriteEntityForDesktopSchema } from '../../repositories/favorites/entities/favorite_entity_for_desktop/FavoriteEntityForDesktopSchema';
import { trackingGoToFavoritesPage } from './tracking';
import { FavoritesList } from '../FavoritesList';
import { EEntityTypes } from '../../repositories/favorites/v1/web-get-user-favorites';

interface IFavoritesModalProps {
  isFavoritesPage: boolean;
  favLink: string;
  canLoadMore: boolean;
  isFetching: boolean;
  favoriteEntities: IFavoriteEntityForDesktopSchema[];
  entityTypes: EEntityTypes.Newbuilding | null;
  closeFavoritesModal(): void;
  updateFavoritesList(length: number): void;
  changeEntityType(entityType: null | EEntityTypes.Newbuilding): void;
}

export const FavoritesModal: React.FC<IFavoritesModalProps> = ({
  isFavoritesPage,
  favLink,
  entityTypes,
  canLoadMore,
  isFetching,
  favoriteEntities,
  updateFavoritesList,
  closeFavoritesModal,
  changeEntityType,
}) => (
  <OutsideClick onOutsideClick={closeFavoritesModal} rootElement={<div className="c-notification-center-container" />}>
    <div className="c-favorites">
      <div className="c-favorites__header">
        <div className="c-header-modal__header c-header-modal__header--favorites">
          <h4 className="c-favorites__header-title">Избранное</h4>
          {!isFavoritesPage && (
            <a
              className="c-favorites__header-link"
              href={favLink}
              rel="nofollow noopener"
              onClick={trackingGoToFavoritesPage}
            >
              <span>Перейти в Избранное</span>
            </a>
          )}
          <div className="c-favorites__entity-type-toggler">
            <span
              {...mergeStyles('c-favorites__entity-type', entityTypes === null && 'c-favorites__entity-type--active')}
              onClick={entityTypes !== null ? () => changeEntityType(null) : undefined}
            >
              Объявления
            </span>
            <span
              {...mergeStyles(
                'c-favorites__entity-type',
                entityTypes === EEntityTypes.Newbuilding && 'c-favorites__entity-type--active',
              )}
              onClick={
                entityTypes !== EEntityTypes.Newbuilding ? () => changeEntityType(EEntityTypes.Newbuilding) : undefined
              }
            >
              ЖК
            </span>
          </div>
        </div>
      </div>
      {isFetching ? (
        <span className="cf-preloader" />
      ) : (
        <FavoritesList
          canLoadMore={canLoadMore}
          favoriteEntities={favoriteEntities}
          entityTypes={entityTypes}
          updateFavoritesList={updateFavoritesList}
        />
      )}
    </div>
  </OutsideClick>
);
